import * as React from "react";
import { useMemo } from "react";
import { Alert, Col, Row } from "components/bootstrap";
import { LICENSE_SUBJECTS } from "license/constants";
import useLicenseValidityForSubject from "license/hooks/useLicenseValidityForSubject";
const licenseStatus = (status) => {
  if (status.valid) {
    return "valid";
  }
  if (status.expired) {
    return "expired";
  }
  return "invalid";
};
const MissingEnterpriseLicense = ({ usesFilters, usesParameters }) => {
  const { data, isInitialLoading: isLoading } = useLicenseValidityForSubject(LICENSE_SUBJECTS.views);
  const inUse = useMemo(
    () => `
  ${usesParameters ? "parameter" : ""}
  ${usesFilters && usesParameters ? " or " : ""}
  ${usesFilters ? "filters" : ""}`,
    [usesFilters, usesParameters]
  );
  if (isLoading) return null;
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: `Your Graylog Enterprise license is ${licenseStatus(data)}` }, `To be able to use ${inUse} support in views, you need to obtain a valid Graylog Enterprise license.
          For further information, please check the `, /* @__PURE__ */ React.createElement("a", { href: "https://www.graylog.org/enterprise", rel: "noopener noreferrer" }, "Graylog Enterprise page"), ".")));
};
export default MissingEnterpriseLicense;
